import styled from '@emotion/styled';
import AsyncImage from 'components/AsyncImage/AsyncImage';
import InputField from 'components/InputField';

export const AsyncImageThumbnail = styled(AsyncImage)`
  width: 100%;
  max-width: 6rem;
  height: 3.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: solid;
`;

export const Input = styled(InputField)`
  max-width: 6rem;
`;
